module.exports = __webpack_public_path__ + "static/media/2024.10.15 Initial Order.c50f46a2.pdf";